import { useCallback, useEffect, useState } from 'react';

type Event<Args> = (...args: Args[]) => void;

export function useFieldFocus<Args extends any[]>(
  onFocus?: Event<Args>,
  onBlur?: Event<Args>,
  disabled?: boolean
): { focused: boolean; handleFocus: Event<Args>; handleBlur: Event<Args> } {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (disabled) {
      setFocused(false);
    }
  }, [disabled]);

  const handleFocus = useCallback(
    (...args: Args) => {
      setFocused(true);

      if (onFocus) {
        onFocus(...args);
      }
    },
    [setFocused, onFocus]
  );

  const handleBlur = useCallback(
    (...args: Args) => {
      setFocused(false);

      if (onBlur) {
        onBlur(...args);
      }
    },
    [setFocused, onBlur]
  );

  return { focused, handleFocus, handleBlur };
}
